import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "专题合集", to: "/special" },
  { label: "关于我们", to: "/about" },
];

const hotGenres = ["悬疑", "科幻", "古装", "青春", "治愈", "音乐"];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-page px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-sm font-black text-primary-950">
                WW
              </span>
              <span className="font-brand text-lg text-background-50">我的快乐在哪里</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              专注影视资讯与剧情介绍的门户网站，为你梳理最新动态、深度解析与优质推荐，让每一次选择观影都更轻松。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">
              <a href="#footer-nav" className="hover:text-accent-400">快速导航</a>
            </h4>
            <ul id="footer-nav" className="space-y-2.5 text-sm text-primary-200">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-accent-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">
              <a href="#footer-genre" className="hover:text-accent-400">热门类型</a>
            </h4>
            <ul id="footer-genre" className="flex flex-wrap gap-2">
              {hotGenres.map((genre) => (
                <li key={genre}>
                  <Link
                    to={`/search?q=${encodeURIComponent(genre)}`}
                    className="inline-flex rounded-full border border-primary-800 px-3 py-1 text-xs text-primary-200 transition-colors hover:border-accent-500 hover:text-accent-400"
                  >
                    {genre}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">
              <a href="#footer-contact" className="hover:text-accent-400">联系我们</a>
            </h4>
            <ul id="footer-contact" className="space-y-3 text-sm text-primary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>内容合作：hello@wwkuaile.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-question-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>意见反馈：feedback@wwkuaile.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" aria-hidden="true" />
                <span>工作日 09:30 - 18:30 回复</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} WW我的快乐在哪里 · 保留所有权利</p>
          <p>本站示例作品名称、剧情与影评均为虚构演示内容，不提供播放与下载服务。</p>
        </div>
      </div>
    </footer>
  );
}